export default {
  pending: 'Pendente de análise',
  agreed: 'Aprovada',
  disagreed: 'Rejeitada',
  canceled: 'Cancelada'
};
